module.exports = __webpack_public_path__ + "img/undraw_check_boxes_m3d0.f8589d2c.svg";